import { render, staticRenderFns } from "./societyMngList.vue?vue&type=template&id=a42ba454&"
import script from "./societyMngList.vue?vue&type=script&lang=js&"
export * from "./societyMngList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports